import { dataLayerPush } from 'src/helpers/gtm';

export const hitActualizePriceChange = (value: {
  packageId: number;
  operator: {
    id: number;
    name: string;
  };
  oldPrice: number;
  newPrice: number;
  hotelCountryIso2: string;
}) => {
  try {
    if (value.oldPrice && value.newPrice && value.oldPrice !== value.newPrice) {
      dataLayerPush({
        event: 'actualize_price_change',
        packageId: value.packageId,
        operator: value.operator,
        oldPrice: value.oldPrice,
        newPrice: value.newPrice,
        hotelCountryIso2: value.hotelCountryIso2,
      });
    }
  } catch (err) {
    console.error(err);
  }
};
